export default __webpack_public_path__ + "static/media/upload.89519f3c.svg";